import { api, PartipostApiResponse, PartipostApiPaginationWrapper } from './'
import {
    TaskState,
    TasksListRequestPayload,
    RegisterTaskRequestPayload,
    UpdateTaskRequestPayload,
    DeleteTaskRequestPayload,
    UpdateTaskPayoutsRequestPayload,
    UpdateTaskScheduleRequestPayload,
    UpdateTasksOrderingRequestPayload,
} from '../../state/tasks'

export type TasksListResponse = PartipostApiPaginationWrapper<TaskState[]>

export const getTasksList = (payload: TasksListRequestPayload) => {
    const { campaignUuid } = payload
    return api.get<PartipostApiResponse<TasksListResponse>>(`campaigns/${campaignUuid}/tasks/`)
}

export const registerTask = (payload: RegisterTaskRequestPayload) => {
    const { taskType, campaignUuid } = payload
    const requestBody = [{ type: taskType }]
    return api.post<PartipostApiResponse<TaskState[]>>(`campaigns/${campaignUuid}/tasks/`, requestBody)
}

export const updateTask = (payload: UpdateTaskRequestPayload) => {
    const { campaignUuid, task } = payload
    return api.patch<PartipostApiResponse<TaskState>>(`campaigns/${campaignUuid}/tasks/${task.uuid}/`, task)
}

export const deleteTask = (payload: DeleteTaskRequestPayload) => {
    const { campaignUuid, taskUuid } = payload
    return api.delete<PartipostApiResponse<TaskState>>(`campaigns/${campaignUuid}/tasks/${taskUuid}/`)
}

export const updateTaskPayouts = (payload: UpdateTaskPayoutsRequestPayload) => {
    const { taskUuid, payouts } = payload
    return api.patch<PartipostApiResponse<TaskState>>(`tasks/${taskUuid}/payouts/`, payouts)
}

export const updateTaskSchedules = (payload: UpdateTaskScheduleRequestPayload) => {
    const { taskUuid, ...rest } = payload
    return api.patch<PartipostApiResponse<TaskState>>(`tasks/${taskUuid}/schedules/`, rest)
}

export const updateTasksOrdering = (payload: UpdateTasksOrderingRequestPayload) => {
    const { campaignUuid, ordering } = payload
    const orderingPayload = ordering.map((taskUuid: string, index: number) => {
        return {
            task_uuid: taskUuid,
            ordering_index: index + 1,
        }
    })
    return api.patch<PartipostApiResponse<TaskState>>(`campaigns/${campaignUuid}/tasks-ordering/`, orderingPayload)
}
